import { render, staticRenderFns } from "./openpay.vue?vue&type=template&id=199bed98"
import script from "./openpay.vue?vue&type=script&lang=js"
export * from "./openpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports